var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-autocomplete",
    _vm._b(
      {
        staticClass: "pt-0",
        attrs: {
          items: _vm.items,
          "menu-props": { closeOnClick: true },
          "hide-selected": "",
          outlined: "",
          dense: "",
          "hide-details": true,
          label: _vm.labelField,
          "item-value": _vm.idField,
          "item-text": _vm.nameField,
          multiple: ""
        },
        scopedSlots: _vm._u([
          {
            key: "prepend-item",
            fn: function() {
              return [
                _c(
                  "v-list-item",
                  {
                    attrs: { ripple: "" },
                    on: {
                      mousedown: function($event) {
                        $event.preventDefault()
                      },
                      click: function($event) {
                        return _vm.toggleSelectAll(_vm.attribute)
                      }
                    }
                  },
                  [
                    _c(
                      "v-list-item-action",
                      [
                        _c("v-icon", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.selectAllIcon) +
                              "\n        "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-item-content",
                      [
                        _c("v-list-item-title", [
                          _vm._v("\n          Basculer Séléction\n        ")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-divider", { staticClass: "mt-2" })
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function({ item }) {
              return [_vm._v("\n    " + _vm._s(item[_vm.nameField]) + "\n  ")]
            }
          },
          {
            key: "selection",
            fn: function({ selected, item }) {
              return [
                _c(
                  "v-chip",
                  {
                    attrs: { small: "", value: selected, close: "" },
                    on: {
                      "click:close": function($event) {
                        return _vm.handleInputRemove(item)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          item[_vm.shortnameField] || item[_vm.nameField]
                        ) +
                        "\n    "
                    )
                  ]
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      },
      "v-autocomplete",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }